import { TextField, TextFieldProps } from '@mui/material'
import React, { forwardRef } from 'react'

export type BaseInputProps = TextFieldProps

const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>((props, ref) => {
  return <TextField inputRef={ref} {...props} />
})

export default BaseInput
